import { Tooltip } from "antd";

export const LEAD_STATUS_CONFIG = {
  "Marketing Qualified": {
    label: "Marketing Qualified",
    bg: "#D4FFDB",
    color: "#45C92B",
  },
  "New Lead": {
    label: "New Lead",
    bg: "#D4DDFF",
    color: "#2B6AC9",
  },
  "Sales Qualified": {
    label: "Sales Qualified",
    bg: "#EED4FF",
    color: "#9C2BC9",
  },
  "Opportunity ": {
    label: "Opportunity",
    bg: "#D4EFFF",
    color: "#2BBEC9",
  },
  Negotiation: {
    label: "Negotiation",
    bg: "#FFFFD4",
    color: "#C9972B",
  },
  "Closed Won": {
    label: "Closed Won",
    bg: "#E5FFD4",
    color: "#87C92B",
  },
  "Closed Lost": {
    label: "Closed Lost",
    bg: "#FFD4D5",
    color: "#C92B2D",
  },
  "Un-Qualified": {
    label: "Un-Qualified",
    bg: "#D4D5FF",
    color: "#2B50C9",
  },
  Deleted: {
    label: "Deleted",
    bg: "#FFE5D4",
    color: "#C95A2B",
  },
};

export const renderLeadStatus = (status, classes) => {
  const config = LEAD_STATUS_CONFIG[status];

  if (!config) return "-";

  return (
    <Tooltip title={config.label}>
      <span
        className={`tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium ${classes}`}
        style={{
          backgroundColor: config.bg,
          color: config.color,
        }}
      >
        {config.label}
      </span>
    </Tooltip>
  );
};
